// extracted by mini-css-extract-plugin
export var Footer = "t6KT3";
export var FooterRow = "gjz37";